import { useQuery } from "@tanstack/react-query";
import { Button, Modal, Spin } from "antd";
import { useState } from "react";
import { CiCircleInfo, CiSquarePlus } from "react-icons/ci";
import { FormattedMessage } from "react-intl";
import { useSelector } from "react-redux";
import { getLoyalty } from "../../../network/settings";
import CardProgramLoyalty from "../CardProgramLoyalty";
import ConFirmDeleteProgram from "../modal/ConFirmDeleteProgram";
import ModalLoyaltyProgram from "../modal/ModalLoyaltyProgram";

type Props = { data: any };

const LoyaltyProgram = ({ data }: Props) => {
  const { locationId } = useSelector((state: any) => state.calendar);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [dataProgram, setDataProgram] = useState(false);
  const [isModalDeleteOpen, setIsModalDeleteOpen] = useState(false);
  const showModal = (data?: any) => {
    setIsModalOpen(true);
    setDataProgram(data || false);
  };
  const closeModal = () => {
    setIsModalOpen(false);
  };
  const showDeleteModal = (data?: any) => {
    setIsModalDeleteOpen(data);
  };
  const closeDeleteModal = () => {
    setIsModalDeleteOpen(false);
  };
  const {
    data: Loyalty,
    isLoading,
    isError,
  } = useQuery(["loyalty"], () => getLoyalty());

  return (
    <>
      <Modal
        width="70%"
        open={isModalOpen}
        centered
        onCancel={closeModal}
        className="max-lg:min-w-[95%] max-xl:min-w-[80%] max-w-[800px]"
        footer={null}
        destroyOnClose
      >
        <ModalLoyaltyProgram close={closeModal} dataProgram={dataProgram} />
      </Modal>
      <Modal
        width="30%"
        open={isModalDeleteOpen}
        centered
        onCancel={closeDeleteModal}
        className="max-md:min-w-[95%] max-lg:min-w-[80%]"
        footer={null}
        destroyOnClose
      >
        <ConFirmDeleteProgram
          isModalDeleteOpen={isModalDeleteOpen}
          close={closeDeleteModal}
        />
      </Modal>
      <div className="bg-[#EEF0FF] rounded-b-lg p-6">
        <div className="w-full p-4 bg-white rounded-lg">
          <div className="flex items-center justify-between mb-8">
            <div className="flex flex-col gap-4">
              <span className="text-[#020418] text-lg font-semibold">
                <FormattedMessage id="loyaltyPrograms.title" />
              </span>
              <p className="text-[#75757E] text-sm">
                <FormattedMessage id="loyaltyPrograms.description" />
              </p>
            </div>
            <Button
              onClick={() => showModal()}
              type="primary"
              className="flex items-center gap-1"
            >
              <CiSquarePlus className="flex items-center" />
              <span>
                <FormattedMessage id="loyaltyPrograms.newButton" />
              </span>
            </Button>
          </div>
          <div className="grid items-center w-full grid-cols-3 gap-5 max-xl:grid-cols-2 max-lg:grid-cols-1">
            {isLoading ? (
              <Spin
                size="large"
                className="flex items-center justify-center col-span-3"
              />
            ) : (
              Loyalty?.data?.map((e: any) => {
                return (
                  <CardProgramLoyalty
                    data={e}
                    isModalOpen={showModal}
                    showDeleteModal={showDeleteModal}
                  />
                );
              })
            )}
          </div>
          <div className="flex items-center justify-center gap-1 mt-8 text-xs text-[#4F5062] w-full">
            <CiCircleInfo />
            <p>
              <FormattedMessage id="loyaltyPrograms.discountApplication" />
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default LoyaltyProgram;
